import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./renn/Logo";
import { NAV_LINKS } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#050A12]/80 backdrop-blur-xl border-b border-[#29354A]/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <Logo className="text-2xl" onClick={() => setOpen(false)} />

        <div className="hidden xl:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="link-underline text-[14px] text-[#8290A8] hover:text-[#F5F7FB] transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a href="#" className="text-[14px] font-medium text-[#F5F7FB] hover:text-[#13D99A] transition-colors px-3 py-2">
            Sign In
          </a>
          <a
            href="#beta"
            className="btn-emerald bg-[#10C98A] text-[#050A12] font-semibold text-[14px] px-5 py-2.5 rounded-full"
          >
            Join the Renn Beta
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-[#F5F7FB]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden fixed inset-0 z-40 transition-opacity duration-300 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
        <div
          className={`absolute right-0 top-0 h-full w-[82%] max-w-sm bg-[#0A1220] border-l border-[#29354A] p-6 flex flex-col transition-transform duration-300 ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between mb-8">
            <Logo className="text-2xl" onClick={() => setOpen(false)} />
            <button className="p-2 text-[#8290A8]" onClick={() => setOpen(false)} aria-label="Close menu">
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#F5F7FB] text-lg font-medium py-3 border-b border-[#29354A]/50"
              >
                {l.label}
              </a>
            ))}
          </div>
          <div className="mt-auto flex flex-col gap-3 pt-6">
            <a href="#" onClick={() => setOpen(false)} className="text-center text-[#F5F7FB] font-medium border border-[#29354A] rounded-full py-3">
              Sign In
            </a>
            <a
              href="#beta"
              onClick={() => setOpen(false)}
              className="text-center bg-[#10C98A] text-[#050A12] font-semibold rounded-full py-3"
            >
              Join the Renn Beta
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
